export default __webpack_public_path__ + "japan.d3bd717f.png";